import { ERRORS } from '../constants/errors'

export class ResponseError extends Error {
  relatedData: any
  response: any
  stackTrace: any
  type: any
  sagaStack: any

  constructor(name: string, response?: any, ...params: any) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ResponseError)
    }

    // Custom debugging information
    this.type = response?.status === 503 ? ERRORS.SERVER_RETRY : ERRORS.TECHNICAL_DIFFICULTIES
    this.message = ['SagaError', name].join('; ')
    this.name = this.message
    this.response = response

    if (response?.data?.localizedMessage) {
      this.message = response?.data?.localizedMessage
    }
    this.stackTrace = response?.data?.stackTrace
    this.relatedData = {
      id: response?.data?.id,
      code: response?.data?.code,
    }
  }
}

export class ComponentError extends Error {
  type: any

  constructor(stack: any, ...params: any) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params)

    // Custom debugging information
    this.stack = stack
    this.type = 'REACT_BOUNDARY'
  }
}
